__turbopack_context__.v({
  "shake": "WordleGuess-module-scss-module__Gc7l7W__shake",
});
